<template>
  <v-simple-table class="dish-table">
    <template #default>
      <colgroup>
        <col class="dish-table__col-thumb" />
        <col />
        <col class="dish-table__col-weight" />
        <col class="dish-table__col-price" />
      </colgroup>
      <thead>
        <tr>
          <th><span class="d-sr-only">Фото</span></th>
          <th>Блюдо</th>
          <th class="text-right">
            Вес
          </th>
          <th class="text-right">
            Цена
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="dish in dishes"
          :key="dish.id"
          class="dish-table__row"
          tabindex="0"
          @click="$emit('dish-open', dish.id)"
          @keydown.enter="$emit('dish-open', dish.id)"
        >
          <td class="dish-table__thumb">
            <dish-image
              :src="dish.image"
              :size="44"
            ></dish-image>
          </td>
          <td>
            <div class="d-flex align-center">
              <span
                class="dish-table__name text-body-2 font-weight-medium text--primary text-truncate"
                :title="dish.name"
              >{{ dish.name }}</span>
              <v-chip
                v-if="!dish.image"
                color="warning"
                x-small
                outlined
                class="dish-table__mark ms-2"
              >
                нет фото
              </v-chip>
            </div>
            <div
              class="text-caption text--secondary text-truncate"
              :title="dish.recipe"
            >
              {{ dish.recipe || '—' }}
            </div>
          </td>
          <td class="dish-table__number text-right text-body-2 text-truncate">
            {{ toWeight(dish.weight) }}
          </td>
          <td class="dish-table__number text-right text-body-2 font-weight-medium text--primary text-no-wrap">
            {{ toMoney(dish.price) }}
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import DishImage from './dish-image.vue'
import { toMoney, toWeight } from '@/helpers/menu'

export default {
  name: 'DishTable',
  components: { DishImage },
  props: {
    dishes: { type: Array, default: () => [] },
  },
  methods: {
    toMoney,
    toWeight,
  },
}
</script>

<style lang="scss" scoped>
.dish-table {
  ::v-deep table {
    min-width: 600px;
    table-layout: fixed;
  }

  ::v-deep .v-data-table__wrapper > table > tbody > tr > td {
    height: 52px;
  }

  ::v-deep .v-data-table__wrapper > table > thead > tr > th {
    height: 40px;
  }

  &__col-thumb {
    width: 68px;
  }

  &__col-weight {
    width: 136px;
  }

  &__col-price {
    width: 116px;
  }

  &__row {
    cursor: pointer;

    &:focus-visible {
      outline: 2px solid var(--v-primary-base);
      outline-offset: -2px;
    }
  }

  &__name {
    min-width: 0;
  }

  &__mark {
    flex: none;
  }

  &__thumb.dish-table__thumb {
    padding-right: 0;
  }

  &__number {
    font-variant-numeric: tabular-nums;
  }
}
</style>
